import { useSelector } from 'react-redux';
import { selectLoadedPlatform } from '../../../../state/slices/slice-link-api';
var useAmountSupported = function () {
    var loadedPlatform = useSelector(selectLoadedPlatform);
    // DD forms search/exit entrypoints - loadedPlatform may not be defined
    return loadedPlatform ? loadedPlatform.amountSupported : true;
};
export default useAmountSupported;
